(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-range-guide"]) return;
  try {
    
(() => {
  function initialise(root) {
    if (root.dataset.bcInitialised) return;
    root.dataset.bcInitialised = 'true';
    const cards = Array.from(root.querySelectorAll('[data-bc-card]'));
    const seen = new Set();
    function emit(action, outcome, productId = '') {
      const key = [action, outcome, productId].join(':');
      const shopify = window.Shopify;
      try {
        if (seen.has(key) || shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof shopify?.analytics?.publish !== 'function') return;
        const receipt = shopify.analytics.publish('bc_growth_interaction', {feature_id: 'range_guide', source_id: root.dataset.sourceId, placement: root.dataset.placement, rule_version: root.dataset.ruleVersion, action, outcome, product_id: productId});
        if (receipt?.catch) receipt.catch(() => {});
        seen.add(key);
      } catch (_) { }
    }
    cards.forEach(card => card.querySelectorAll('a').forEach(link => link.addEventListener('click', () => emit('product_click', card.dataset.purpose, card.dataset.productId))));
    if (typeof IntersectionObserver === 'function') {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) { emit('impression', 'visible', entry.target.dataset.productId); } });
      }, {threshold: 0.5});
      cards.forEach(card => observer.observe(card));
      document.addEventListener('visitorConsentCollected', () => {
        cards.forEach(card => { if (!card.hidden) { const rect = card.getBoundingClientRect(); if (rect.top >= 0 && rect.bottom <= window.innerHeight) emit('impression', 'visible', card.dataset.productId); } });
      });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); });
    }
    const form = root.querySelector('[data-bc-selector]');
    if (!form) return;
    const result = form.querySelector('[data-bc-result]');
    const contact = form.querySelector('[data-bc-contact]');
    const message = kind => form.querySelector(`[data-message-${kind}]`).textContent;
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const purpose = form.elements.purpose.value;
      const matches = cards.filter(card => card.dataset.purpose === purpose);
      cards.forEach(card => { card.hidden = !matches.includes(card); });
      let outcome = 'stale';
      if (purpose === 'sizing' || purpose === 'other') outcome = purpose;
      else if (matches.length) outcome = matches.some(card => card.dataset.available === 'true') ? 'match' : 'unavailable';
      result.textContent = message(outcome);
      contact.hidden = outcome === 'match';
      emit('selector_result', `${purpose}_${outcome}`);
    });
    form.addEventListener('reset', () => {
      cards.forEach(card => { card.hidden = false; });
      result.textContent = message('reset');
      contact.hidden = true;
    });
    form.hidden = false;
  }
  function scan(scope) { scope.querySelectorAll('[data-bc-growth]').forEach(initialise); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
